export default __webpack_public_path__ + "static/media/aff3a009e688676cc479d66fc1efacad4535f9744de7c570b750ba84f75ff4d4.fe2571ae.png";